export const TRIGGER_LEAVE_TIMEOUT = 100;
export const MENU_LEAVE_TIMEOUT = 50;
export const MENU_CLOSE_TIMEOUT = 100;
